module.exports = __webpack_public_path__ + "img/375.6a201aa8.jpg";